import type { RUNGS } from '@marva/shared/action-classes'
import {
  RUNG_COPY as SHARED_RUNG_COPY,
  RUNG_MEANING_COPY as SHARED_RUNG_MEANING_COPY,
  type RungCopy
} from '@marva/shared/authority-copy'

/**
 * The rung vocabulary — one copy, shared by the Authority screen and Ask's
 * proposal card (MAR-175), so a change Ask prepares is named in exactly the
 * words of the screen that shows the rung.
 *
 * The words themselves live in `@marva/shared/authority-copy` (MAR-300), beside the statements Ask
 * reads through `read_authority`, so the screen and Ask's answer come from one module.
 */
export type Rung = (typeof RUNGS)[number]

export const RUNG_COPY: Readonly<Record<Rung, RungCopy>> = SHARED_RUNG_COPY

/** The "What <rung> means" line on the Authority screen — the same shared module. */
export const RUNG_MEANING_COPY = SHARED_RUNG_MEANING_COPY

/** A rung's display name; an unknown value is shown as itself rather than hidden. */
export const rungName = (rung: string | null | undefined): string =>
  rung && Object.prototype.hasOwnProperty.call(RUNG_COPY, rung) ? RUNG_COPY[rung as Rung].name : (rung ?? '—')
